/* eslint-disable no-case-declarations */
import { Checkbox } from "mondrian-react"
import { useRouter } from "next/router"
import React, { useCallback, useEffect, useRef, useState } from "react"
import { useFeatureFlag, useForm, useSessionStorage, useTagging } from "../../hooks"
import ModalService from "../../services/ModalService"
import validationService from "../../services/ValidationService"
import { sendLead } from "./lead-service"
import ResidentialInfoService from "../../services/ResidentialInfoService"

import { CustomInput } from "../../shared"
import ClienteBase from "../Modals/clienteBase"
import styles from "./styles.module.scss"


const EcomFormBoxApp = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { query } = useRouter()
  const pageName = query?.id
  const pageCategory = `plano-claro-res:cobertura:${pageName}`
  const numberRef = useRef<HTMLInputElement>(null)
  const [residentialInfo, setResidentialInfo] = useState({
    cpf: "",
    checked: false
  })

  const { getItem: getTvIdItem } = useSessionStorage("tvId")
  const { getItem: getCepItem } = useSessionStorage("cep")
  const { getItem: getNumberItem } = useSessionStorage("number")
  const { getItem: getUserItem } = useSessionStorage("user")
  const { setItem: setLeadIdItem } = useSessionStorage("leadId")

  const [checkboxValues, setCheckboxValues] = useState({
    withoutNumber: false,
    whatsapp: true
  })

  const { state, checkmark, debouncedStates, errors, handleBlur, handleChange, handleFocus, setState, formIsValid, setErrors, setCheckmark } = useForm({
    inputs: [
      {
        id: 'cpf',
        defaultValue: '',
        label: 'cpf',
        type: 'text',
        validationType: 'cpf',
      },
      {
        id: 'name',
        defaultValue: '',
        label: 'nome',
        type: 'text',
        validationType: 'name',
      },
      {
        id: 'email',
        defaultValue: '',
        label: 'email',
        type: 'text',
        validationType: 'email',
      },
      {
        id: 'phone',
        defaultValue: '',
        label: 'celular',
        type: 'text',
        validationType: 'phone',
      },
      {
        id: 'rg',
        defaultValue: '',
        label: 'rg',
        type: 'text',
        validationType: 'rg',
      },
      {
        id: 'birthdate',
        defaultValue: '',
        label: 'nascimento',
        type: 'text',
        validationType: 'birthdate',
      },
      {
        id: 'motherName',
        defaultValue: '',
        label: 'nome-da-mae',
        type: 'text',
        validationType: 'name',
      },
      {
        id: 'cep',
        defaultValue: '',
        label: 'cep',
        type: 'text',
        validationType: 'cep',
        focusAfterFill: numberRef
      },
      {
        id: 'number',
        defaultValue: '',
        label: 'numero',
        type: 'text',
        validationType: 'number',
        maxLength: 8
      },
    ],
    tagging: {
      category: pageCategory,
    }
  })

  const { handleTagging } = useTagging(pageCategory)
  const { featureFlag } = useFeatureFlag()


  const handleFormSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault()
      setIsLoading(true)
      handleTagging({
        eventAction: "clique:botao",
        eventLabel: `prosseguir-endereco`
      })
      if (!formIsValid) return      
      try {
        sessionStorage.setItem("cep", state.cep.replace("-", ""))
        sessionStorage.setItem("number", state.number)
        const formData = {
          ...state,
          productType: pageName,
          whatsapp: checkboxValues.whatsapp,
          withoutNumber: checkboxValues.withoutNumber
        }
        const response = await sendLead(formData, true, featureFlag)
        const tvIds = getTvIdItem()
        // const urlDadosPessoais = `/checkout/endereco/?leadId=${response}&tvId=${tvIds}`
        const urlDadosPessoais = `/novo/checkout?leadId=${response}&tvId=${tvIds}`
        setLeadIdItem(response)
        window.location.href = urlDadosPessoais
      } catch (error) {
        console.error("Erro ao enviar o formulário:", error)
      }finally {
        setIsLoading(false)
      }
    },
    [formIsValid, state, checkboxValues, sendLead, getTvIdItem, pageName]
  )

  const handleResidentialInfo = useCallback(
    async (cpf) => {
      const response = await ResidentialInfoService.getResidentialInfo(cpf)
      if (!response.error && response.data?.status === "CONECTADO") {
        ModalService.open({
          title: "Olá, notamos que você já é cliente Claro!",
          component: ClienteBase,
          size: "sm",
          componentProps: undefined,
          showHeader: false,
          taguear: true,
          tags: {
            abertura: {
              event: "event",
              eventCategory: "planos-claro-res:cobertura:modal-ja-e-cliente",
              eventAction: "modal:abriu",
              eventLabel: "ja-e-cliente"
            },
            fechamento: {
              event: "event",
              eventCategory: "planos-claro-res:cep:modal-ja-e-cliente",
              eventAction: "modal:fechou",
              eventLabel: "ja-e-cliente"
            }
          }
        })
      }

      setResidentialInfo({
        cpf,
        checked: true
      })
    },
    [setResidentialInfo]
  )

  const handleWithoutNumber = useCallback(() => {
    handleTagging({
      eventAction: `${!checkboxValues.withoutNumber ? "marcou" : "desmarcou"
        }:sem-numero:checkbox`,
      eventLabel: `checkbox:${withoutNumber}:sem-numero:plano-claro-res:cobertura:${pageName}`
    })
    setCheckboxValues((prev) => ({
      ...prev,
      withoutNumber: !prev.withoutNumber
    }))
    setState({ ...state, number: checkboxValues.withoutNumber ? "" : "0" })
    setErrors({ ...errors, number: "" })
    setCheckmark({ ...checkmark, number: checkboxValues.withoutNumber ? "none" : "success" })
  }, [
    checkboxValues.withoutNumber,
    handleTagging,
    pageName,
    setCheckboxValues,
    setState,
    setErrors,
    setCheckmark,
    state,
    errors,
    checkmark
  ])

  const handleWhastapp = useCallback(() => {
    handleTagging({
      eventAction: `${checkboxValues.whatsapp ? "desmarcou" : "marcou"
        }:o-acompanhamento-por-whatsapp:checkbox`,
      eventLabel: `checkbox:whatsapp:plano-claro-res:cobertura:${pageName}`
    })
    setCheckboxValues((prev) => ({
      ...prev,
      whatsapp: !prev.whatsapp
    }))
  }, [
    checkboxValues.whatsapp,
    handleTagging,
    pageName,
    setCheckboxValues
  ])

  useEffect(() => {
    const user = JSON.parse(getUserItem())
    const cep = getCepItem()
    const number = getNumberItem()

    if (!user || !cep || !number) return

    const { cpf, motherName, name, other, phone, rg, email, birthdate } = user as any
    const formattedPhone = `${phone.area}${phone.number.trim()}`
    const date = birthdate.split("-")
    const formattedBirthdate = `${date[2]}/${date[1]}/${date[0]}`

    setState({
      ...state,
      birthdate: formattedBirthdate,
      name,
      email,
      cpf,
      motherName,
      rg,
      phone: formattedPhone,
      cep: cep,
      number
    })
    setCheckboxValues({
      withoutNumber: number === "0",
      whatsapp: true
    })
  }, [])

  useEffect(() => {
    // residential info rules
    const cpfIsValid = validationService.cpf(debouncedStates.cpf).valid

    if (!cpfIsValid) return
    if (residentialInfo.checked && residentialInfo.cpf === debouncedStates.cpf)
      return
    handleResidentialInfo(debouncedStates.cpf)
  }, [debouncedStates.cpf, residentialInfo])

  useEffect(() => {
    // lead rule
    const minLeadInputs = ["cpf", "phone", "email"]
    const additionalInfoInputs = [
      "rg",
      "birthdate",
      "cep",
      "number",
      "name",
      "motherName"
    ]

    const validMinLead = minLeadInputs
      .map((input) => {
        const valid = validationService[input]?.(debouncedStates[input]).valid
        return valid
      })
      .every((input) => input)

    const validAdditionalInfo = additionalInfoInputs
      .map((input) => {
        if (!debouncedStates[input]) return true
        const valid = validationService[input]?.(debouncedStates[input]).valid
        return valid
      })
      .every((input) => input)

    if (!validMinLead) return
    if (!validAdditionalInfo) return

    sendLead(debouncedStates)
  }, [debouncedStates, validationService])


  const withoutNumber = state.number !== "0" ? "marcou" : "desmarcou"

  return (
    <form className={styles.formContainer} onSubmit={handleFormSubmit}>
      <div className={styles.inputsContainer}>
        <div>
          <CustomInput
            checkmark={checkmark.cpf}
            label="CPF - Somente números*"
            id="cpf"
            name="cpf"
            mask="cpf"
            value={state.cpf}
            errorMessage={errors.cpf}
            hasError={Boolean(errors.cpf)}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
          />
          <CustomInput
            checkmark={checkmark.name}
            label="Nome*"
            id="name"
            name="name"
            value={state.name}
            errorMessage={errors.name}
            hasError={Boolean(errors.name)}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
          />
        </div>

        <div>
          <CustomInput
            checkmark={checkmark.email}
            label="E-mail*"
            id="email"
            name="email"
            mask="none"
            value={state.email}
            errorMessage={errors.email}
            hasError={Boolean(errors.email)}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            tooltipText="Caracteres acentuados não são permitidos no campo de e-mail."
          />

          <CustomInput
            checkmark={checkmark.phone}
            label="Celular*"
            id="phone"
            name="phone"
            mask="phone"
            value={state.phone}
            errorMessage={errors.phone}
            hasError={Boolean(errors.phone)}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
          />
        </div>

        <div>
          <div className={styles.inputDouble}>
            <CustomInput
              checkmark={checkmark.rg}
              label="RG*"
              id="rg"
              name="rg"
              value={state.rg}
              errorMessage={errors.rg}
              hasError={Boolean(errors.rg)}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={handleFocus}
            />

            <CustomInput
              checkmark={checkmark.birthdate}
              label="Nascimento*"
              id="birthdate"
              name="birthdate"
              mask="birthdate"
              value={state.birthdate}
              errorMessage={errors.birthdate}
              hasError={Boolean(errors.birthdate)}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={handleFocus}
              unmask
            />
          </div>
          <CustomInput
            checkmark={checkmark.motherName}
            label="Nome da mãe completo*"
            id="motherName"
            name="motherName"
            value={state.motherName}
            errorMessage={errors.motherName}
            hasError={Boolean(errors.motherName)}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
          />
        </div>

        <div>
          <CustomInput
            checkmark={checkmark.cep}
            label="CEP*"
            id="cep"
            name="cep"
            mask="cep"
            value={state.cep}
            errorMessage={errors.cep}
            hasError={Boolean(errors.cep)}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
          />
          <CustomInput
            checkmark={checkmark.number}
            label="Número*"
            id="number"
            name="number"
            value={state.number}
            errorMessage={errors.number}
            hasError={Boolean(errors.number)}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            disabled={checkboxValues.withoutNumber}
            ref={numberRef}
          />
        </div>
      </div>

      <div className={styles.checkboxWrapper}>
        <div>
          <Checkbox
            checked={checkboxValues.withoutNumber}
            onChange={handleWithoutNumber}
            id="withoutNumber"
          >
            Meu endereço não possui número.
          </Checkbox>
        </div>

        <div>
          <Checkbox
            checked={checkboxValues.whatsapp}
            onChange={handleWhastapp}
            id="whatsApp"
          >
            Aceito acompanhar o andamento do meu pedido por WhatsApp
          </Checkbox>
        </div>
      </div>

      <div className={styles.buttonWrapper}>
        <button type="submit" disabled={!formIsValid || isLoading}>
          {isLoading ? "Enviando..." : "Prosseguir para o Endereço"}
        </button>
      </div>
    </form>
  )
}

export default EcomFormBoxApp
